import Urls from "./Urls";
import Http from './../utils/Http';

const OtpService = {
    
    send: async function(companyName, otpMethod, contact) {
		const url = otpMethod === 'email' ? Urls.SEND_OTP_TO_EMAIL : Urls.SEND_OTP_TO_PHONE;
        return await Http.postData(url, { companyName, contact  });
    },
    
    validate: async function(contact, otp) {
        return await Http.postData(Urls.VALIDATE_OTP, { contact, otp });
    }
};

export default OtpService;